import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {scrollTriggerConfig, duration, scrolling} from "./animation";
import {setActiveNavItem} from "./nav";

const animateContact = () => {
  const sectionId = 'contact';
  const sectionDuration = duration[sectionId];

  const el = {
    main: '.section-contact .container',
    showcaseBody: '.section-showcase .section__body',
  };

  const animate = () => {
    return {
      enter: {
        main: {
          from: { y: '100vh', transformOrigin: 'bottom' },
          to: { y: 0 },
        },
      },
    }
  };

  ScrollTrigger.create({
    id: sectionId,
    trigger: `.section-${sectionId}`,
    ...scrollTriggerConfig,
    onEnter: (self) => {
      setActiveNavItem();

      scrolling.disable();

      gsap.fromTo(el.main, { ...animate().enter.main.from }, { ...animate().enter.main.to, duration: sectionDuration, onComplete: scrolling.enable });
      gsap.set(el.showcaseBody, { transitionDelay: 0 });

      //disables header when footer is in view
      document.querySelector('.header').classList.add('header__hidden');
    },
    onLeaveBack: (self) => {
      scrolling.disable();
      gsap.to(el.main, { ...animate().enter.main.from, duration: sectionDuration, onComplete: scrolling.enable });
      gsap.set(el.showcaseBody, { clearProps: 'transition-delay' });

      //enables header when footer leaves view
      document.querySelector('.header').classList.remove('header__hidden');
    },
  });
}

export default animateContact;
